/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography, Button } from '@mui/material';
import { externalURLs } from 'const';
import { CameraIcon, VirtualIcon } from 'components/elements/Icons';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function AppointmentVirtualAddress({ isToday, onJoinAppointment }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  return (
    <Box className={classes.addressWrapper} data-testid="appointment-detail-address">
      <>
        <div className={classes.virtualIconWrapper} data-testid="appointment-virtual">
          <VirtualIcon classes={classes.virtualIcon} />
        </div>
        <div className={classes.virtualJoinWrapper}>
          <Typography sx={{ fontWeight: 'bold' }} color="text" variant="h6" component="h6">
            {t('virtual_appointment')}
          </Typography>
          {isToday && (
            <Button className={classes.appointmentJoinButton} onClick={onJoinAppointment} variant="contained">
              <CameraIcon classes={classes.joinButtonIcon} />
              <Typography className={classes.controlButtonText} variant="span" component="span">
                {t('join')}
              </Typography>
            </Button>
          )}
          <Typography className={classes.guideText} color="text" variant="body1" component="span">
            {t('if_you_are_having_trouble_with_your_virtual_appointment_please_refer_to_this')}
            <a className={classes.guideLink} sx={{ textTransform: 'lowercase' }} target="_blank" href={externalURLs.videoSessionSupport} rel="noreferrer">
              {' '}
              {t('guide')}
            </a>
          </Typography>
        </div>
      </>
    </Box>
  );
}

AppointmentVirtualAddress.propTypes = {
  isToday: PropTypes.bool.isRequired,
  onJoinAppointment: PropTypes.func,
};

AppointmentVirtualAddress.defaultProps = {
  onJoinAppointment: () => {},
};

export default AppointmentVirtualAddress;
